export default "__VITE_PUBLIC_ASSET__454c0f36__"